var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "custom-class": "layout-dialog",
            "show-close": false,
            title: "予定日時設定",
            top: "5vh",
            width: "900px",
            visible: _vm.dialogVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            { staticClass: "sure_box top_info mtn top_box" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("予定日時")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 20 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(" " + _vm._s(_vm.dayTime) + " "),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box",
                      staticStyle: { "padding-top": "0px" },
                      attrs: { span: 24 },
                    },
                    [_c("vab-calendar-span", { ref: "calendar" })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer flex_end mg12",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                { staticClass: "flex_start flex_center_align" },
                [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }